import React from 'react';

const CrossIconNew = ({ size = 24, fill = '#260735', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M20.9499 22.364L9.63615 11.0503C9.2496 10.6637 9.2496 10.0226 9.63615 9.63604C10.0227 9.24949 10.6638 9.24949 11.0504 9.63604L22.3641 20.9497C22.7506 21.3363 22.7506 21.9774 22.3641 22.364C21.9775 22.7505 21.3364 22.7505 20.9499 22.364Z"
      fill={fill}
    />
    <path
      d="M9.63592 22.364C9.24937 21.9774 9.24937 21.3363 9.63592 20.9497L20.9496 9.63604C21.3362 9.24949 21.9773 9.24949 22.3638 9.63604C22.7504 10.0226 22.7504 10.6637 22.3638 11.0503L11.0501 22.364C10.6636 22.7505 10.0225 22.7505 9.63592 22.364Z"
      fill={fill}
    />
  </svg>
);

export default CrossIconNew;
